import React from "react";
import { useSpring, animated } from "@react-spring/web";

interface CCLogoProps {}

const CCLogoProps: React.FC<CCLogoProps> = ({}) => {
  // Define the animation for the "drawing" effect
  const drawAnimation = useSpring({
    from: { strokeDashoffset: 1000, fill: "transparent" },
    to: { strokeDashoffset: 0, fill: "white" },
    config: { duration: 3000 },
  });

  return (
    <div
      id="CCLogo"
      className="fixed top-1 left-1 md:top-4 md:left-4 w-32 md:w-40 z-20 outline-none select-none"
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1000 360.9245"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <animated.path
          style={drawAnimation}
          opacity={0.1}
          fill="#FFFFFF"
          transform="translate(100, 50)"
          d="M286.9,215.3c-12.3-10.6-23.5-22.5-35.3-34l40.3-53c3.8,7.7,7.2,15.4,11.3,22.5
	c7.5,12.8,16.2,24.9,30.3,31.3c20.4,9.2,40.3,6.5,59.2-4.6c8.5-5,16.5-11,25.1-16.8l31.8,44.8c-13.3,9.5-27.7,17.4-42.8,23.7
	c-14.4,5.9-29.2,10.6-44.9,10.9c-1.1,0-2.3,0-3.4,0C331.9,240.1,307.4,233,286.9,215.3L286.9,215.3z M34.8,204
	c-14.4-12.5-22.3-29.7-28.5-47.6c-4.8-13.9-7.4-28.3-5.9-43c2.1-20.3,8.9-39.1,18.9-56.9c17.7-31.4,45-48.3,79.9-54.3
	c34.8-5.9,66.8-0.4,95.3,21.5c2.6,2,5.3,4,7.8,6.2s4.8,4.6,7.6,7.3c-9.4,11.1-18.1,21.7-27.2,32.1c-5.7,6.5-5.9,6.3-13,1
	c-12-9-24.8-16.1-39.7-19.3c-18.8-4.1-35.1,0.9-49.1,13.4c-12.5,11.2-21.9,25-24.6,41.6c-3.5,21.7,0.1,42.6,13.8,60.7
	c8.7,11.5,20.6,18.4,34.6,21.8c16.7,4,32.1,0.1,46.8-7.7c17.9-9.5,32.2-23.3,44.1-39.5c22.2-30.1,44.1-60.4,66.3-90.5
	c17.2-23.4,38.9-40.6,67.9-47.1c39.2-8.7,75.1-1,107.7,22.4c4.3,3.1,8,6.8,12.5,10.6c-11.4,12.8-22.4,25.2-33.7,37.8
	c-9.9-8.9-20.5-16.5-33.2-20.5c-15.5-4.9-31.3-7.8-47.1-1.6c-13.5,5.3-23.7,15-32.2,26.5c-17,22.9-33.4,46.2-50.9,68.6
	c-12.4,16-26.3,30.9-39.4,46.3c-9.2,10.8-19.2,20.7-31.8,27.7c-15.5,8.7-32.3,12.6-49.8,15.1c-5.2,0.7-10.5,1.1-15.7,1.1
	C85.1,237.8,58.6,224.5,34.8,204z"
        />

        <animated.text
          x="0"
          y="170"
          fontFamily="ABC Favorit, Helvetica, sans-serif"
          fontWeight="300"
          fontSize="160"
          fill="none" // Start with no fill
          stroke="white" // Set stroke color
          strokeWidth="1"
          strokeDasharray="1000"
          style={drawAnimation} // Apply the drawing animation
        >
          collectie
        </animated.text>
        <animated.text
          x="0"
          y="280"
          fontFamily="ABC Favorit, Helvetica, sans-serif"
          fontWeight="300"
          fontSize="160"
          fill="none"
          stroke="white"
          strokeWidth="1"
          strokeDasharray="1000"
          style={drawAnimation} // Apply the drawing animation
          transform-origin="100% 50%"
        >
          connectie
        </animated.text>
      </svg>
    </div>
  );
};

export default CCLogoProps;
